module.exports = __webpack_public_path__ + "static/media/screen4.899adea9.png";